import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import BaseModal, { modalStyles, HoverButton } from './BaseModal';
import ModalStickyFooter from '../ui/ModalStickyFooter';
import { colors, typography } from '../../styles/theme';

interface CameraPermissionModalProps {
  visible: boolean;
  onTryAgain: () => void;
}

export default function CameraPermissionModal({ visible, onTryAgain }: CameraPermissionModalProps) {
  return (
    <BaseModal 
      visible={visible} 
      onClose={onTryAgain}
      animationType="fade"
      isFullScreenOnMobile={false}
      header={(
        <>
          <Text style={modalStyles.headerText}>Camera Access Required</Text>
          <Text style={modalStyles.subtitleText}>
            Please allow camera permissions in your browser or device settings to play the game.
          </Text>
        </>
      )}
      footer={(
        <ModalStickyFooter>
          <HoverButton 
            style={modalStyles.primaryButton} 
            hoverStyle={modalStyles.primaryButtonHover}
            textStyle={modalStyles.primaryButtonText}
            onPress={onTryAgain}
          >
            Try Again
          </HoverButton>
        </ModalStickyFooter>
      )}
    >
    </BaseModal>
  );
}
